import React, { useRef } from "react";
import ConsultationForm from "../../components/ConsultationForm";
import "../style.css";
import IncludedSection from "../../components/IncludedSection";
import CallIcon from "../../assets/Icons/call-icon.svg"; 

const Container = (props) => {
  return (
    <div className="container">
      <p className="text-wrapper-12">{props.header}</p>

      <p className="from-initial">{props.desc}</p>
    </div>
  );
};
const Frame = (props) => {
  return (
    <div className="frame">
      <div className="div-2">
        <div className="text-wrapper-3">{props.header2}</div>
      </div>

      <p className="language-frame-p mt-4">{props.desc}</p>
    </div>
  );
};

export default function LearnMoreSection(props) {
  const formSectionRef = useRef(null);
  const handleFocusSection = () => {
    formSectionRef.current.scrollIntoView({ behavior: "smooth" });
    formSectionRef.current.focus();
  };
  const data = props.learnMoreData;
  return (
    <div className=" course-finder-container-background p-4 personal-guidence ">
      <Container header={data.headerSec.header} desc={data.headerSec.desc} />

      <div
        className="language-section-image-text "
        style={{ paddingTop: "50px" }}
      >
        <img
          className="language-rectangle-2"
          alt="Rectangle"
          src={data.secondSection.img}
        />

        <Frame
          header2={data.secondSection.header}
          desc={data.secondSection.desc}
        />
      </div>

      <IncludedSection includedSectionData={data.thirdSection} />
      {data.fourthSection && (
        <section className="learn-more">
          <Container
            header={data.fourthSection.header}
            desc={data.fourthSection.desc}
          />
          <div ref={formSectionRef} className="card-form frame-4">
            <ConsultationForm
              enablePaymentRedirection={data.enablePaymentRedirection}
            />
            <div className="container-21">
              <div className="background-shadow-2">
                <div className="container-22">
                  <img
                    className="overlay"
                    alt="Overlay"
                    src="https://c.animaapp.com/XwKqq1VA/img/overlay.svg"
                  />

                  <div className="container-23">
                    <div className="heading-3">
                      <div className="text-wrapper-25">Email Us</div>
                    </div>

                    <div className="container-24">
                      <div className="text-wrapper-26">
                        <a
                          href="mailto:info@globalstudyin.com"
                          className="text-blue-600 underline hover:text-blue-800 transition-colors duration-200"
                        >
                          info@globalstudyin.com
                        </a>
                      </div>
                    </div>

                    <div className="container-26">
                      <p className="text-wrapper-27">
                        We&#39;ll respond within 24 hours
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="background-shadow-2 custom-h-100">
                <div className="container-22">
                  <img
                    className="overlay"
                    alt="Overlay"
                    src={CallIcon}
                  />

                  <div className="container-23">
                    <div className="heading-3">
                      <div className="text-wrapper-25">Contact Us</div>
                    </div>

                    <div className="container-24">
                      <div className="text-wrapper-26">+44 20 7277 6666</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="background-shadow-4">
                <div className="container-29">
                  <div className="div-3">
                    <div className="text-wrapper-29">
                      Why Students Choose Us
                    </div>
                  </div>

                  <div className="container-30">
                    <div className="container-31">
                      <img
                        className="SVG-4"
                        alt="Svg"
                        src="https://c.animaapp.com/XwKqq1VA/img/svg-7.svg"
                      />

                      <div className="container-32">
                        <div className="text-wrapper-30">
                          10000+ Students Successfully Placed
                        </div>
                      </div>
                    </div>

                    <div className="container-31">
                      <img
                        className="SVG-4"
                        alt="Svg"
                        src="https://c.animaapp.com/XwKqq1VA/img/svg-8.svg"
                      />

                      <div className="container-32">
                        <div className="text-wrapper-30">
                          200+ Partner Universities
                        </div>
                      </div>
                    </div>

                    <div className="container-31">
                      <img
                        className="SVG-4"
                        alt="Svg"
                        src="https://c.animaapp.com/XwKqq1VA/img/svg-9.svg"
                      />

                      <div className="container-32">
                        <div className="text-wrapper-30">
                          25+ Years of Experience
                        </div>
                      </div>
                    </div>

                    <div className="container-31">
                      <img
                        className="SVG-4"
                        alt="Svg"
                        src="https://c.animaapp.com/XwKqq1VA/img/svg-10.svg"
                      />

                      <div className="container-32">
                        <div className="text-wrapper-30">
                          24/7 Student Support
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </div>
  );
}
